module.exports = __webpack_public_path__ + "img/video_menu_setting.35df8f00.svg";